import React from "react";
import doubleHappiness from "../../assets/image/xixi_2.svg";
import styles from "./not-found.module.css";

function NotFound() {
  return (
    <div className={styles.container}>
      <div className={styles.errorContent}>
        <h1 className={styles.errorCode}>404</h1>
        <h2 className={styles.errorMessage}>Page Not Found</h2>
        <p className={styles.description}>
          Oops! The page you're looking for doesn't exist. It might have been
          removed or you mistyped the URL.
        </p>
      </div>
      <div className={styles.animationContainer}>
        <img src={doubleHappiness} alt="Lost" className={styles.image} />
      </div>
    </div>
  );
}

export default NotFound;
